import React from "react";
import { Form, Spinner, Row, Col, CardBody, Card, Alert } from "reactstrap";

import SelectRequestType from "./SelectRequestType";
import DefaultForm from "./DefaultForm";
import OtherForm from "./OtherForm";

const PublicGovernmentRequestForm: React.FC<{
  loading: boolean;
  isUpdate?: boolean;
  validation: any;
  fieldErrors: any;
}> = ({ validation, isUpdate, loading, fieldErrors }) => {
  return (
    <Form
      className="tablelist-form"
      onSubmit={(e) => {
        e.preventDefault();
        validation.handleSubmit();
        return false;
      }}
    >
      {fieldErrors.length > 0 && (
        <div className="mb-3">
          <Alert color="danger" className="material-shadow">
            {fieldErrors.map((error: any, index: any) => (
              <div key={index}>
                <strong>{error.field}:</strong> {error.message}
              </div>
            ))}
          </Alert>
        </div>
      )}
      <Row>
        <Col md={12} className="mb-3">
          <Card>
            <CardBody className="">
              <SelectRequestType validation={validation} />
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              {validation.values.requestType === "Other" && (
                <OtherForm validation={validation} />
              )}
              {validation.values.requestType !== "Other" && (
                <DefaultForm validation={validation} />
              )}
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <Row className="mb-1">
                <div className="hstack gap-2 justify-content-between">
                  <button type="button" className="btn btn-light">
                    Back
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading && (
                      <Spinner
                        color="light"
                        size="sm"
                        style={{ marginRight: "8px", marginBottom: "-1px" }}
                      />
                    )}
                    {isUpdate ? "Update Request" : "Submit Request"}
                  </button>
                </div>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Form>
  );
};

export default PublicGovernmentRequestForm;
